/* Afrivolt · theme.js — interactions */
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.site-mobile-toggle');
  const mobileNav = document.querySelector('.site-mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.innerHTML = open ? '<span style="font-size:20px;">✕</span>' : '<span style="font-size:20px;">☰</span>';
    });
  }

  document.querySelectorAll('.mobile-dropdown-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const panel = btn.nextElementSibling;
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      if (panel) panel.classList.toggle('is-open', !open);
    });
  });

  document.querySelectorAll('[data-filter-group]').forEach(group => {
    const chips = group.querySelectorAll('.filter-chip');
    chips.forEach(chip => {
      chip.addEventListener('click', () => {
        chips.forEach(c => c.classList.remove('is-active'));
        chip.classList.add('is-active');
        const filter = chip.dataset.filter || 'all';
        const grid = group.closest('section, .wrap, main')?.querySelector('[data-filter-grid]');
        if (!grid) return;
        grid.querySelectorAll('[data-filter-tag]').forEach(card => {
          const tags = (card.dataset.filterTag || '').split(',').map(x => x.trim());
          card.style.display = (filter === 'all' || tags.includes(filter)) ? '' : 'none';
        });
      });
    });
  });

  document.querySelectorAll('.blog-chips .chip, .uc-tab').forEach(chip => {
    chip.addEventListener('click', () => {
      const scope = chip.closest('.blog-chips, .uc-tabs') || document;
      scope.querySelectorAll('.chip, .uc-tab').forEach(c => c.classList.remove('is-active'));
      chip.classList.add('is-active');
    });
  });

  document.querySelectorAll('.form-segmented, .seg-control').forEach(seg => {
    seg.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        seg.querySelectorAll('button').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const target = btn.dataset.target;
        if (target) {
          document.querySelectorAll('[data-seg-panel]').forEach(panel => { panel.hidden = panel.dataset.segPanel !== target; });
        }
      });
    });
  });

  document.querySelectorAll('.cfg-row').forEach(row => {
    row.querySelectorAll('.cfg-opt').forEach(opt => {
      opt.addEventListener('click', () => {
        row.querySelectorAll('.cfg-opt').forEach(o => o.classList.remove('is-active'));
        opt.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('.gallery-thumbs .thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.gallery-thumbs .thumb').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const src = thumb.dataset.src;
      const img = document.querySelector('.gallery-main img, #gallery-main-img');
      if (src && img) img.src = src;
    });
  });

  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', e => {
      const btn = form.querySelector('button[type=submit]');
      if (btn) setTimeout(() => { btn.textContent = 'Envoyé ✓'; }, 0);
    });
  });

  document.querySelectorAll('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async e => {
      if (!form.querySelector('[data-add-btn]')) return;
      e.preventDefault();
      const btn = form.querySelector('[data-add-btn]');
      const variantId = form.querySelector('[name=id]')?.value;
      if (!variantId || !btn) return;
      btn.disabled = true; btn.textContent = 'Ajout en cours…';
      try {
        const res = await fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:variantId, quantity:1})});
        if (!res.ok) throw new Error('add failed');
        btn.textContent = 'Ajouté au panier ✓';
        setTimeout(() => { btn.disabled = false; btn.textContent = 'Ajouter au panier'; }, 2200);
      } catch(e) { btn.disabled = false; btn.textContent = 'Erreur — réessayer'; }
    });
  });
});
